const Themes = [
  {
    background: "#faf8f2",
    text: "#faf8f2",
    main: "#ff5100",
    footer: "linear-gradient(90deg, #4ef58b, #9effc1)",
    button: "#33ff7e",
    link: "#ff5100",
  },
];

export default Themes;
